import styled from '@emotion/styled';
import type { ReactNode } from 'react';
import React from 'react';
import { Provider as ToastProvider } from 'shared/providers/Toaster';

import { GridArea } from 'src/shared/constants';

import { Header } from './Header';
import { Main } from './Main';
import { SkipLink } from './SkipLink';

interface LayoutProps {
  children: ReactNode;
}

const Container = styled.div`
  display: grid;
  grid-template-areas:
    '${GridArea.HEADER}'
    '${GridArea.MAIN}'
    '${GridArea.FOOTER}';
  grid-template-columns: 1fr;
  grid-template-rows: auto 1fr auto;
  min-height: 100vh;
`;

const Layout = ({ children }: LayoutProps) => (
  <Container>
    <SkipLink />
    <Header />
    <Main>
      <ToastProvider>{children}</ToastProvider>
    </Main>
  </Container>
);

export { Layout };
